<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Organizations
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-select
              v-model="orgtype"
              :items="[
                {text:'All',value:false},
                {text:'Course Providers', value: 'course_provider'},
                {text:'Employers', value:'employer'}
                ]"
              @change="getDataFromApi()"
              label="Org Type"
              single-line
              >
            </v-select>
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
          >
          
          <template v-slot:item.name="{item}">
            {{ item.name }} 
            <v-icon v-if="!item.active" color="error">mdi-eye-off-outline</v-icon>
          </template>
          <template v-slot:item.isCourseProvider="{ item }">
            <v-icon v-if="item.isCourseProvider" color="success">mdi-check</v-icon>
            <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
          </template> 
          <template v-slot:item.isEmployer="{ item }">
            <v-icon v-if="item.isEmployer" color="success">mdi-check</v-icon>
            <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
          </template> 
          <template v-slot:item.report="{ item }">
            <template v-if="item.isCourseProvider">
              <a 
                :href="'/admin/reports/org/'+item.id+'/courses'" target="_blank">
                <v-icon
                  small
                  class="mr-2"
                  
                >
                  mdi-chart-bar
                </v-icon>
              </a>
            </template>
            <template v-if="item.isEmployer">
              <a 
                :href="'/admin/reports/org/'+item.id+'/jobs'" target="_blank">
                <v-icon
                  small
                  class="mr-2"
                  
                >
                  mdi-chart-bar
                </v-icon>
              </a>
            </template>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="edit(item.id)"
            >
              mdi-pencil
            </v-icon>
            <a 
                :href="baseurl+'/organization/'+item.alias" target="_blank">
              <v-icon
                small
                class="mr-2"
                
              >
                mdi-eye
              </v-icon>
            </a>
            <v-icon
              v-if="!item.active"
              small
              class="mr-2"
              @click="deactivateAll(item)"
            >
              mdi-close-circle-multiple-outline
            </v-icon>
          </template>
        </v-data-table>
        </v-card> 

        <v-dialog v-model="dialogAdd"  fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialogAdd = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="dialogType == 'add'">Add New Organization</v-toolbar-title>
          <v-toolbar-title v-if="dialogType == 'edit'">Edit {{neworganization.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                v-if="dialogType=='add'"
              dark
              text
              @click="saveAddDialog"
            >
              Add
            </v-btn>
            <v-btn
                v-if="dialogType=='edit'"
              dark
              text
              @click="saveEditDialog"
            >
              Update
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
              <v-container v-if="errors">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-alert type="error">
                      <ul>
                        <li v-for="e in errors">
                          {{ e[0] }}
                        </li>
                      </ul>
                      
                    </v-alert>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-autocomplete
                      v-model="neworganization.user_id"
                      label="User"
                      :items="users"
                      item-text="email"
                      item-value="id"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-img :src="neworganization.photo_path" height="40" width="40">
                    </v-img>
                    <v-file-input
                        accept="image/*"
                      v-model="neworganization.photo"
                      label="Normal Picture"
                      prepend-icon="mdi-camera"
                      clearable
                      
                    ></v-file-input>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    v-if="0"
                  >
                    <v-img :src="neworganization.square_photo_path" height="40" width="40">
                    </v-img>
                    <v-file-input
                        accept="image/*"
                      v-model="neworganization.squarephoto"
                      label="Square Picture"
                      prepend-icon="mdi-camera"
                      clearable
                      
                    ></v-file-input>
                  </v-col>
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.name"
                      label="Name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.alias"
                      label="Alias"
                      hint="No spaces or special characters, e.g. my-organization"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.email"
                      label="Email"
                      prepend-icon="mdi-email"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.phone"
                      label="Phone"
                      prepend-icon="mdi-phone"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.url"
                      label="URL"
                      hint="https://www.example.com"
                      prepend-icon="mdi-web"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.contact_name"
                      label="Contact Name"
                      hint="Displayed on the organization page"
                      prepend-icon="mdi-user"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <hr/>
                
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    Social Media
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.facebook"
                      label="Facebook"
                      hint="https://www.facebook.com/myurl"
                      prepend-icon="mdi-facebook"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.instagram"
                      label="Instagram"
                      hint="https://www.instagram.com/myurl"
                      prepend-icon="mdi-instagram"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.twitter"
                      label="Twitter"
                      hint="https://www.twitter.com/myurl"
                      prepend-icon="mdi-twitter"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.linkedin"
                      label="LinkedIn"
                      hint="https://www.linkedin.com/myurl"
                      prepend-icon="mdi-linkedin"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <hr/>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    Address
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select
                      v-model="neworganization.region"
                      label="Region"
                      :items="regions"
                      clearable
                    ></v-select>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.address"
                      label="Address"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.postal_code"
                      label="Postal Code"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                </v-row>
                <hr/>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    Spotlight Links
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.spotlight_url"
                      label="Spotlight Blog Url"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.spotlight_image"
                      label="Spotlight Image Url"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.spotlight_image_title"
                      label="Spotlight Title"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.spotlight_video"
                      label="Spotlight Video Url"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="neworganization.spotlight_video_title"
                      label="Spotlight Video Title"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <hr/>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <span class="text-h6">Description</span>
                    <vue-editor
                      v-model="neworganization.description"
                      label="Description"
                    ></vue-editor>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                    <v-switch
                      v-model="neworganization.active"
                      label="Active"
                    ></v-switch>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                  <v-switch
                      v-model="neworganization.is_featured"
                      label="Featured"
                    ></v-switch>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                  <v-switch
                      v-model="neworganization.is_returner_friendly"
                      label="Returner Friendly"
                    ></v-switch>
                </v-col>
                </v-row>
              </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="dialogType == 'add'"
                color="blue darken-1"
                text
                @click="saveAddDialog"
              >
                Add New
              </v-btn>
              <v-btn
                v-if="dialogType == 'edit'"
                color="blue darken-1"
                text
                @click="saveEditDialog"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" >
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  
  import { VueEditor } from "vue2-editor";
  const passwordLength = 12
  const passwordChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

  export default {
    props: {
      organizations: Array,
      users:Array,
      regions:Array,
      baseurl:String,
    },
    components: {
      Head,
      VueEditor
    },
    layout: Layout,
    data() {
        return {
            list: [],
            orgtype: "All",
            keyword: "",
            location: "",
            category: "",
            total: this.organizations.length,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            options: {},
            errors: false,
            search: "",
            headers: [
              { text: 'ID', value:'id'},
              { text: 'Name', value:'name'},
              { text: 'Email', value:'email'},
              { text: 'Courses', value:'isCourseProvider'},
              { text: 'Jobs', value:'isEmployer'},
              { text: 'Report', value:'report'},
              { text: 'Actions', value:'actions'}

            ],
            neworganization: {
              name:"",//
              email: "",//
              user_id: "",//
              alias: "",//
              phone: "",//
              url: "",//
              facebook: "",//
              twitter: "",//
              instagram: "",//
              linkedin: "",//
              contact_name: "",//
              description: "",//
              active: false,
              is_featured:false,
              is_returner_friendly:false,
              spotlight_url:"",
              spotlight_image:"",
              spotlight_image_title:"",
              spotlight_video:"",
              spotlight_video_title:"",
              address: "",//
              city: "",//
              region: "",//
              postal_code: "",//
              photo: [],
              squarephoto: [],
            },
            dialogType:'add',
            dialogAdd: false,
            dialogDelete: false
        }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    created() {
      this.list = JSON.parse(JSON.stringify(this.organizations));
    },
    methods: {
      deactivateAll(item) {
        console.log('deactivate',item)
        if (item.isCourseProvider)
        {
          axios.get("/admin/organizations/deactivateCourses/"+item.id).then((response) => { 
            if (response && response.data && response.data == 1) 
              alert('Success'); 
            else
              alert('Something went wrong.');
           });
        }
        else if (item.isEmployer)
        {
          axios.get("/admin/organizations/deactivateJobs/"+item.id).then((response) => { 
            if (response && response.data && response.data == 1) 
              alert('Success'); 
            else
              alert('Something went wrong.');
          });
        }
      },
      searchJobs() {
            this.$inertia.get(this.baseurl+'/search/job', 
                {organization:this.organization.alias}, 
                {}) 
        },
      edit(id) {
        console.log('attempting to edit id ',id)
        axios.get("/admin/organizations/get/"+id).then((response) => {
            console.log('edit got response',response.data)

            if (response && response.data)
            {
                this.neworganization = response.data
                this.dialogAdd = true;
                this.dialogType='edit';
            }
        });
      },
      addNew(){
        this.dialogType='add';
        Object.keys(this.neworganization).forEach(key => {
            if (key == 'photo')
                this.neworganization.key = []
            else if (key == 'squarephoto')
                this.neworganization.key = []
            else
                this.neworganization[key] = "";
        });
        this.dialogAdd = true;
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search, role: this.role, type:this.orgtype};

        axios.get("/admin/organizations/list",{ params: params }).then((response) => {
          this.list = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },
      saveEditDialog () {
        this.loadingAdd=true;
        this.errors = false
        const formData = new FormData()
        Object.keys(this.neworganization).forEach(key => formData.append(key, this.neworganization[key]));
        axios.post("/admin/organizations/update",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Edit failed');
          
            console.log('edit response',response)
            this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      saveAddDialog () {
        this.loadingAdd=true;
        this.errors = false
        console.log('adding organization',this.neworganization)
        const formData = new FormData()
        Object.keys(this.neworganization).forEach(key => formData.append(key, this.neworganization[key]));

        axios.post("/admin/organizations/add",formData).then((response) => {
          console.log('add response',response)
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Add failed');
          
            console.log('add response',response)
          this.loadingAdd = false;
        })
        .catch(error => {
            console.log('error on add',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  